import { z } from 'zod';

export const shopAlertPreferencesSchema = z.object({
  lowStockPush: z.boolean(),
  marginAlertPush: z.boolean(),
  creditOverduePush: z.boolean(),
  dailyDigestEnabled: z.boolean(),
  /** Hour (0–23) in Africa/Lagos for daily digest delivery. */
  digestHourLocal: z.number().int().min(0).max(23),
});

export const updateShopAlertPreferencesSchema = shopAlertPreferencesSchema.partial();

export type ShopAlertPreferences = z.infer<typeof shopAlertPreferencesSchema>;
